export default __webpack_public_path__ + "static/emojivoto-tracing-729df381dac9379b0bcb3ea199eb935e.webp";